module.exports = __webpack_public_path__ + "img/Physics.ba20f7c9.svg";